import { PageContainer, WalletOrCredit, Icons } from 'components';
import { useForm } from 'react-hook-form';
import { Button } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import useCustomHook from '../hooks';
import { constBreadCrumbsTitle } from 'utility';
const ReceiveInventory = () => {
  const { methodType, setMethodType } = useCustomHook();
  //HOOKS//
  const location = useLocation();
  const methods = useForm();
  const navigate = useNavigate();

  
  return (
    <PageContainer
      title="موجودی تنخواه"
      pageKey="requestConfirmation"
      description={'امکان دریافت موجودی از طرف کسب و کار تنخواه گردان'}
      breadcrumbs={constBreadCrumbsTitle.IMPREST_RECEIVE_INVENTORY}
      meta={
        <Button
          onClick={() => navigate(-1)}
          color="primary"
          endIcon={<Icons icon="CaretLeft" color="#2b3990" size="23" />}
          variant="outlined"
        >
          بازگشت
        </Button>
      }
    >
      <WalletOrCredit
        methods={methods}
        methodType={methodType}
        setMethodType={setMethodType}
        showWalletAmount={true}
        walletNameService={'getCredit'}
        walletPrams={{
          userId: location?.state?.userId,
          wallet: 'PODLAND_WALLET',
        }}
        guildNameSerivece={'guild'}
        useSelectedGuildForShowSomething={true}
        paramsRelatedToCallUseSelectedGuildSrv={location?.state?.id}
      />
    </PageContainer>
  );
};

export default ReceiveInventory;
